import { BusinessChallenges } from '@platform/client';
import { DeleteChallengeRequestChallengeNumber } from '@platform/client/schemas';
import { Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';

export const DeleteChallengeModal = ({
  organizationId,
  challengeNumber,
  isOpen,
  onClose,
}: {
  organizationId: number;
  challengeNumber: number;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const queryClient = useQueryClient();
  const deleteChallengeMutator = BusinessChallenges.useClearChallengeData({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: BusinessChallenges.getGetOrganizationBusinessChallengesQueryKey(organizationId),
        });
        onClose();
      },
    },
  });
  return (
    <Modal
      variant='dialog'
      isOpen={isOpen}
      onClose={onClose}
      title='Delete business challenge?'
      headerDivision='divider'
      primaryCTA={{
        text: 'Remove',
        buttonVariant: 'primary-danger',
        callback: () =>
          deleteChallengeMutator.mutate({
            organizationId,
            data: { challenge_number: challengeNumber as DeleteChallengeRequestChallengeNumber },
          }),
      }}
      secondaryCTA={{
        text: 'Go back',
        callback: onClose,
      }}
      ignoreExtraPadding
    >
      <p>
        <b>"Challenge {challengeNumber}"</b> will be removed from your dashboard. This can't be undone.
      </p>
    </Modal>
  );
};
